import { QueryClient } from "@tanstack/react-query";

/** 管理后台的查询客户端：保持默认行为，刷新频繁的低延迟数据可单独覆盖。 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
